import { combineReducers } from 'redux'
import {
  progressReducer,
  userReducer,
  sectionLengthReducer,
  sectionReducer,
  genderReducer,
  ageReducer,
  interstitialReducer,
  tokenReducer,
  globalIdReducer,
  responseCompleteReducer,
  resultsResponseCompleteReducer,
  dynamicSectionLengthReducer,
  directionReducer,
  globalUnmountReducer,
  revealProgressReducer,
  setSubscriptionIdReducer,
  setCustomerIdReducer,
  setIsMhmdReducer,
  setMhmdStateReducer,
  setMhmdOptedReducer,
  setHeaderVariantReducer,
} from '../reducers'

export const rootReducer = combineReducers({
  progressReducer,
  userReducer,
  sectionLengthReducer,
  sectionReducer,
  genderReducer,
  ageReducer,
  interstitialReducer,
  tokenReducer,
  globalIdReducer,
  responseCompleteReducer,
  resultsResponseCompleteReducer,
  dynamicSectionLengthReducer,
  directionReducer,
  globalUnmountReducer,
  revealProgressReducer,
  setSubscriptionIdReducer,
  setCustomerIdReducer,
  setIsMhmdReducer,
  setMhmdStateReducer,
  setMhmdOptedReducer,
  setHeaderVariantReducer,
})
